/* Guías "Para empezar". Ver el contrato de campos en ../guides.js */

export const GUIDES_START = [
  {
    slug: 'first-steps',
    id: 'get-started',
    category: 'start',
    icon: 'flag',
    level: 'basic',
    plan: 'free',
    minutes: 4,
    topics: [
      'començar', 'instal·lar', 'descarregar', 'primer cop', 'empezar', 'instalar', 'descargar',
      'primera vez', 'no sé por dónde empezar', 'get started', 'install', 'download', 'first time',
      'set up nukli', 'nuevo usuario', 'com funciona', 'cómo funciona la app',
    ],
    ca: {
      title: 'Primers passos: instal·lar Nukli i obrir-la',
      lead: 'Des de zero fins a tenir els teus correus a dins. Són quatre minuts i no cal saber res de tècnica.',
      answer:
        'Baixa Nukli des de nukliapp.com/download (o obre-la al navegador a mail.nukliapp.com), crea el compte i connecta la teva adreça de correu. La primera descàrrega de missatges va sola en segon pla.',
      steps: [
        {
          t: 'Baixa el programa',
          d: 'Vés a nukliapp.com/download. La pàgina ja reconeix si tens Mac, Windows o Linux i et destaca el botó correcte. Si no vols instal·lar res, obre mail.nukliapp.com i tindràs la mateixa app dins del navegador.',
        },
        {
          t: 'Instal·la i obre',
          d: 'Al Mac, arrossega Nukli a la carpeta Aplicacions. A Windows, executa l’instal·lador i segueix-lo fins al final. Després obre Nukli com qualsevol altre programa.',
        },
        {
          t: 'Crea el compte de Nukli',
          d: 'És el compte del programa, no el del teu correu. Amb el correu i una contrasenya n’hi ha prou. Aquest compte és el que et permet fer servir Nukli també al navegador i al telèfon.',
        },
        {
          t: 'Connecta la teva adreça de correu',
          d: 'Aquí sí que hi poses el teu correu de sempre (Gmail, Outlook, el de la feina…). Si et perds en aquest pas, tens una guia sencera dedicada: “Connecta el teu correu”.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Deixa que baixin els missatges',
          d: 'Els correus més recents arriben primer i la resta van entrant sols mentre tu ja hi voltes. No cal esperar amb la pantalla encesa: pots tancar-ho i continuar més tard.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Fes una volta',
          d: 'La primera vegada Nukli et fa un petit tour de quatre pantalles. Si el vas saltar, el pots tornar a veure des de la configuració, a “Tour de benvinguda”.',
        },
      ],
      tips: [
        'No cal pagar res per començar: el pla gratuït ja porta assistent, traducció i correcció.',
        'Si el Mac diu que el programa és d’un “desenvolupador no identificat”, obre’l amb el botó dret > Obre la primera vegada.',
      ],
      faq: [
        {
          q: 'He de canviar de correu o crear-me’n un de nou?',
          a: 'No. Nukli és una manera diferent de llegir el correu que ja tens. La teva adreça i els teus missatges continuen sent els mateixos.',
        },
        {
          q: 'Perdré els correus antics?',
          a: 'No. Nukli no esborra res del servidor: només se’ls mira. Si un dia desinstal·les l’app, el teu correu segueix on era.',
        },
      ],
    },
    es: {
      title: 'Primeros pasos: instalar Nukli y abrirla',
      lead: 'De cero a tener tus correos dentro. Son cuatro minutos y no hace falta saber nada de informática.',
      answer:
        'Descarga Nukli en nukliapp.com/download (o ábrela en el navegador en mail.nukliapp.com), crea la cuenta y conecta tu dirección de correo. La primera descarga de mensajes va sola en segundo plano.',
      steps: [
        {
          t: 'Descarga el programa',
          d: 'Entra en nukliapp.com/download. La página ya reconoce si tienes Mac, Windows o Linux y te destaca el botón correcto. Si prefieres no instalar nada, abre mail.nukliapp.com y tendrás la misma app dentro del navegador.',
        },
        {
          t: 'Instala y abre',
          d: 'En Mac, arrastra Nukli a la carpeta Aplicaciones. En Windows, ejecuta el instalador y sigue hasta el final. Después abre Nukli como cualquier otro programa.',
        },
        {
          t: 'Crea la cuenta de Nukli',
          d: 'Es la cuenta del programa, no la de tu correo. Con un email y una contraseña basta. Esa cuenta es la que te deja usar Nukli también en el navegador y en el móvil.',
        },
        {
          t: 'Conecta tu dirección de correo',
          d: 'Aquí sí pones tu correo de siempre (Gmail, Outlook, el del trabajo…). Si te atascas en este paso, tienes una guía entera dedicada: “Conecta tu correo”.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Deja que bajen los mensajes',
          d: 'Los correos más recientes llegan primero y el resto van entrando solos mientras tú ya curioseas. No hace falta esperar con la pantalla encendida: puedes cerrar y seguir más tarde.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Date una vuelta',
          d: 'La primera vez Nukli te hace un pequeño tour de cuatro pantallas. Si lo saltaste, puedes volver a verlo desde los ajustes, en “Tour de bienvenida”.',
        },
      ],
      tips: [
        'No hace falta pagar para empezar: el plan gratuito ya trae asistente, traducción y corrección.',
        'Si el Mac dice que el programa es de un “desarrollador no identificado”, ábrelo con el botón derecho > Abrir la primera vez.',
      ],
      faq: [
        {
          q: '¿Tengo que cambiar de correo o crearme uno nuevo?',
          a: 'No. Nukli es otra manera de leer el correo que ya tienes. Tu dirección y tus mensajes siguen siendo los mismos.',
        },
        {
          q: '¿Voy a perder los correos antiguos?',
          a: 'No. Nukli no borra nada del servidor: solo los mira. Si algún día desinstalas la app, tu correo sigue donde estaba.',
        },
      ],
    },
    en: {
      title: 'First steps: installing and opening Nukli',
      lead: 'From nothing to your mail inside the app. It takes four minutes and no technical knowledge.',
      answer:
        'Download Nukli from nukliapp.com/download (or open it in your browser at mail.nukliapp.com), create your account and connect your email address. The first download of messages runs on its own in the background.',
      steps: [
        {
          t: 'Download the app',
          d: 'Go to nukliapp.com/download. The page already knows whether you are on Mac, Windows or Linux and highlights the right button. If you would rather not install anything, open mail.nukliapp.com and you get the same app inside your browser.',
        },
        {
          t: 'Install it and open it',
          d: 'On a Mac, drag Nukli into the Applications folder. On Windows, run the installer and follow it to the end. Then open Nukli like any other program.',
        },
        {
          t: 'Create your Nukli account',
          d: 'This is the account for the app, not for your mail. An email and a password are enough. That account is what lets you use Nukli in the browser and on your phone too.',
        },
        {
          t: 'Connect your email address',
          d: 'Here you do use your everyday address (Gmail, Outlook, your work one…). If you get stuck on this step there is a whole guide for it: “Connect your email”.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Let the messages come down',
          d: 'The most recent emails arrive first and the rest keep coming in while you look around. You do not have to sit and wait: close it and come back later if you like.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Have a look around',
          d: 'The first time, Nukli shows you a short four-screen tour. If you skipped it, you can replay it from settings under “Welcome tour”.',
        },
      ],
      tips: [
        'You do not have to pay to start: the free plan already includes the assistant, translation and proofreading.',
        'If your Mac says the app is from an “unidentified developer”, open it with right-click > Open the first time.',
      ],
      faq: [
        {
          q: 'Do I have to change my email address or make a new one?',
          a: 'No. Nukli is a different way of reading the mail you already have. Your address and your messages stay exactly the same.',
        },
        {
          q: 'Will I lose my old emails?',
          a: 'No. Nukli never deletes anything from the server, it only reads it. If you uninstall the app one day, your mail is still there.',
        },
      ],
    },
  },

  {
    slug: 'connect-your-email',
    id: 'add-account',
    category: 'start',
    icon: 'mail-plus',
    level: 'basic',
    plan: 'free',
    minutes: 5,
    topics: [
      'afegir compte', 'connectar correu', 'gmail', 'outlook', 'hotmail', 'icloud', 'imap', 'smtp',
      'añadir cuenta', 'conectar correo', 'add account', 'connect email', 'contraseña de aplicación',
      'app password', 'contrasenya d’aplicació', 'no me conecta el correo', 'servidor', 'yahoo',
    ],
    ca: {
      title: 'Connecta el teu correu (Gmail, Outlook o qualsevol altre)',
      lead: 'Nukli no et dona una adreça nova: fa servir la que ja tens. Aquí veuràs com enganxar-la.',
      answer:
        'Vés a Configuració (l’engranatge de baix de tot de la barra d’icones) i obre la pestanya “Comptes”. Prem el botó “Afegeix un compte”, escriu la teva adreça i deixa que Nukli detecti la configuració. Amb Gmail o Outlook t’enviarà a la pàgina del proveïdor per autoritzar-ho; amb altres correus et demanarà la contrasenya.',
      steps: [
        {
          t: 'Obre la configuració',
          d: 'L’engranatge de baix de tot de la barra estreta d’icones de l’esquerra. S’obre una pantalla amb pestanyes a dalt.',
          screen: 'settings-accounts',
          highlight: 'rail',
        },
        {
          t: 'Vés a la pestanya “Comptes”',
          d: 'És la tercera de la fila de dalt, entre “General” i “Assistents”. Hi surten els comptes que ja tens.',
          screen: 'settings-accounts',
          highlight: 'tabs',
        },
        {
          t: 'Prem “Afegeix un compte”',
          d: 'El botó fosc de la dreta de la targeta “Comptes”.',
          screen: 'settings-accounts',
          highlight: 'add',
        },
        {
          t: 'Escriu la teva adreça',
          d: 'Només l’adreça, res més. Nukli buscarà sol quins són els servidors del teu proveïdor: no cal que sàpigues què vol dir IMAP.',
          tip: 'Si Nukli ja et suggereix una adreça, és perquè l’ha vist configurada en aquest mateix ordinador. Només és un suggeriment.',
        },
        {
          t: 'Autoritza o posa la contrasenya',
          d: 'Amb Gmail o Microsoft s’obre la pàgina del proveïdor perquè hi entris tu: Nukli mai no veu la teva contrasenya. Amb la resta de correus (iCloud, el del teu domini…) et demanarà una contrasenya d’aplicació.',
        },
        {
          t: 'Espera els primers correus',
          d: 'Quan el compte queda afegit, veuràs les carpetes a l’esquerra i els correus començaran a omplir la llista. Els més recents primer.',
          screen: 'inbox',
          highlight: 'list',
        },
      ],
      tips: [
        'Una “contrasenya d’aplicació” és una contrasenya especial de 16 lletres que el teu proveïdor genera només per a aquest programa. La pots anul·lar quan vulguis sense tocar la teva contrasenya de sempre.',
        'Amb Gmail, Google encara pot ensenyar un avís d’“aplicació no verificada”. Prem “Configuració avançada” i després “Ves a Nukli”: la connexió és segura, entres a la pàgina de Google mateix.',
      ],
      faq: [
        {
          q: 'Em demana un servidor IMAP i no en tinc ni idea',
          a: 'Prova primer només amb l’adreça: gairebé sempre Nukli el troba sol. Si no, obre “Avançat” i escriu-hi el que t’hagi donat el teu proveïdor (normalment imap.eldomini.com i smtp.eldomini.com).',
        },
        {
          q: 'Diu que la contrasenya no és correcta i n’estic segur',
          a: 'Amb iCloud i amb Gmail no serveix la contrasenya normal: cal la contrasenya d’aplicació. La generes a la web del proveïdor i l’enganxes aquí.',
        },
      ],
    },
    es: {
      title: 'Conecta tu correo (Gmail, Outlook o cualquier otro)',
      lead: 'Nukli no te da una dirección nueva: usa la que ya tienes. Aquí verás cómo engancharla.',
      answer:
        'Ve a Ajustes (el engranaje del fondo de la barra de iconos) y abre la pestaña “Cuentas”. Pulsa el botón “Añadir cuenta”, escribe tu dirección y deja que Nukli detecte la configuración. Con Gmail u Outlook te llevará a la página del proveedor para autorizarlo; con otros correos te pedirá la contraseña.',
      steps: [
        {
          t: 'Abre los ajustes',
          d: 'El engranaje del fondo de la barra estrecha de iconos de la izquierda. Se abre una pantalla con pestañas arriba.',
          screen: 'settings-accounts',
          highlight: 'rail',
        },
        {
          t: 'Ve a la pestaña “Cuentas”',
          d: 'Es la tercera de la fila de arriba, entre “General” y “Asistentes”. Ahí salen las cuentas que ya tienes.',
          screen: 'settings-accounts',
          highlight: 'tabs',
        },
        {
          t: 'Pulsa “Añadir cuenta”',
          d: 'El botón oscuro de la derecha de la tarjeta “Cuentas”.',
          screen: 'settings-accounts',
          highlight: 'add',
        },
        {
          t: 'Escribe tu dirección',
          d: 'Solo la dirección, nada más. Nukli buscará solo cuáles son los servidores de tu proveedor: no necesitas saber qué significa IMAP.',
          tip: 'Si Nukli ya te sugiere una dirección es porque la ha visto configurada en este mismo ordenador. Es solo una sugerencia.',
        },
        {
          t: 'Autoriza o pon la contraseña',
          d: 'Con Gmail o Microsoft se abre la página del proveedor para que entres tú: Nukli nunca ve tu contraseña. Con el resto de correos (iCloud, el de tu dominio…) te pedirá una contraseña de aplicación.',
        },
        {
          t: 'Espera los primeros correos',
          d: 'Cuando la cuenta queda añadida verás las carpetas a la izquierda y los correos empezarán a llenar la lista. Los más recientes primero.',
          screen: 'inbox',
          highlight: 'list',
        },
      ],
      tips: [
        'Una “contraseña de aplicación” es una contraseña especial de 16 letras que tu proveedor genera solo para este programa. Puedes anularla cuando quieras sin tocar tu contraseña de siempre.',
        'Con Gmail, Google todavía puede mostrar un aviso de “aplicación no verificada”. Pulsa “Configuración avanzada” y luego “Ir a Nukli”: la conexión es segura, entras en la propia página de Google.',
      ],
      faq: [
        {
          q: 'Me pide un servidor IMAP y no tengo ni idea',
          a: 'Prueba primero solo con la dirección: casi siempre Nukli lo encuentra solo. Si no, abre “Avanzado” y escribe lo que te haya dado tu proveedor (normalmente imap.tudominio.com y smtp.tudominio.com).',
        },
        {
          q: 'Dice que la contraseña no es correcta y estoy seguro de que sí',
          a: 'Con iCloud y con Gmail no vale la contraseña normal: hace falta la contraseña de aplicación. La generas en la web del proveedor y la pegas aquí.',
        },
      ],
    },
    en: {
      title: 'Connect your email (Gmail, Outlook or any other)',
      lead: 'Nukli does not give you a new address: it uses the one you already have. Here is how to plug it in.',
      answer:
        'Go to Settings (the cog at the bottom of the icon bar) and open the “Accounts” tab. Press the “Add account” button, type your address and let Nukli detect the settings. With Gmail or Outlook it sends you to the provider’s own page to authorise it; with other providers it asks for a password.',
      steps: [
        {
          t: 'Open settings',
          d: 'The cog at the bottom of the narrow icon bar on the left. A screen with tabs across the top opens.',
          screen: 'settings-accounts',
          highlight: 'rail',
        },
        {
          t: 'Go to the “Accounts” tab',
          d: 'Third along the top row, between “General” and “Assistants”. It lists the accounts you already have.',
          screen: 'settings-accounts',
          highlight: 'tabs',
        },
        {
          t: 'Press “Add account”',
          d: 'The dark button on the right of the “Accounts” card.',
          screen: 'settings-accounts',
          highlight: 'add',
        },
        {
          t: 'Type your address',
          d: 'Just the address, nothing else. Nukli looks up your provider’s servers on its own: you do not need to know what IMAP means.',
          tip: 'If Nukli already suggests an address, it is because it saw one configured on this computer. It is only a suggestion.',
        },
        {
          t: 'Authorise it or enter the password',
          d: 'With Gmail or Microsoft, the provider’s own page opens so that you sign in there: Nukli never sees your password. For other providers (iCloud, your own domain…) it asks for an app password.',
        },
        {
          t: 'Wait for the first emails',
          d: 'Once the account is added you will see the folders on the left and emails will start filling the list, newest first.',
          screen: 'inbox',
          highlight: 'list',
        },
      ],
      tips: [
        'An “app password” is a special 16-letter password your provider creates just for this program. You can revoke it any time without touching your normal password.',
        'With Gmail, Google may still show an “unverified app” warning. Press “Advanced” and then “Go to Nukli”: the connection is safe — you sign in on Google’s own page.',
      ],
      faq: [
        {
          q: 'It asks for an IMAP server and I have no idea',
          a: 'Try the address alone first: Nukli almost always finds it. If not, open “Advanced” and enter what your provider gave you (usually imap.yourdomain.com and smtp.yourdomain.com).',
        },
        {
          q: 'It says the password is wrong and I am sure it is right',
          a: 'With iCloud and Gmail the normal password does not work: you need the app password. Generate it on your provider’s website and paste it here.',
        },
      ],
    },
  },

  {
    slug: 'several-addresses',
    id: 'multiple-accounts',
    category: 'start',
    icon: 'mails',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'diverses adreces', 'varios correos', 'varias cuentas', 'multiple accounts', 'two emails',
      'personal y trabajo', 'todas las bandejas', 'all inboxes', 'canviar de compte', 'cambiar de cuenta',
      'desde qué cuenta envío', 'remitente', 'sender',
    ],
    ca: {
      title: 'Diverses adreces a la mateixa safata',
      lead: 'La del correu personal, la de la feina i la de l’associació, totes juntes i sense barrejar-se.',
      answer:
        'Pots afegir tants comptes com vulguis des del panell de bústies. A dalt de tot hi ha “Totes les safates”, que ho ensenya tot junt; a sota, cada compte amb les seves carpetes. En respondre, tria l’adreça del remitent al camp “De”.',
      steps: [
        {
          t: 'Afegeix el segon compte',
          d: 'Igual que el primer: bústies > Afegeix un compte. No hi ha límit i cada compte manté les seves carpetes.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Mira-ho tot junt o d’un en un',
          d: 'A dalt de la columna hi ha “Totes les safates”: barreja els correus de tots els comptes per ordre d’hora. Just a sota tens cada compte per separat si prefereixes anar-hi un a un.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Comprova des d’on envies',
          d: 'Quan responguis, mira el camp “De” a dalt de la resposta. Nukli tria l’adreça a la qual va arribar el correu, però la pots canviar amb un clic.',
          screen: 'reply',
          highlight: 'foot',
        },
        {
          t: 'Dona un assistent a cada adreça',
          d: 'A Configuració > Assistents pots assignar comptes a cada assistent. Així el to i la signatura de la feina no es fiquen mai als correus personals.',
          screen: 'settings-assistants',
          highlight: 'list',
        },
      ],
      tips: [
        'Si un compte et fa nosa un dia concret, plega’l a la columna de bústies amb la fletxa del seu nom.',
        'Els grups de carpetes ajuden molt quan tens tres comptes: mira la guia “Ordena la barra lateral”.',
      ],
      faq: [
        {
          q: 'Es barrejaran els correus de la feina amb els personals?',
          a: 'Només a la vista “Totes les safates”, i perquè tu ho has demanat. Els correus no es mouen mai de lloc ni canvien de compte.',
        },
      ],
    },
    es: {
      title: 'Varias direcciones en la misma bandeja',
      lead: 'La del correo personal, la del trabajo y la de la asociación, todas juntas y sin mezclarse.',
      answer:
        'Puedes añadir tantas cuentas como quieras desde el panel de buzones. Arriba del todo está “Todas las bandejas”, que lo enseña todo junto; debajo, cada cuenta con sus carpetas. Al responder, elige la dirección de envío en el campo “De”.',
      steps: [
        {
          t: 'Añade la segunda cuenta',
          d: 'Igual que la primera: buzones > Añadir cuenta. No hay límite y cada cuenta mantiene sus carpetas.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Míralo todo junto o de una en una',
          d: 'Arriba de la columna está “Todas las bandejas”: mezcla los correos de todas las cuentas por hora. Justo debajo tienes cada cuenta por separado si prefieres ir una a una.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Comprueba desde dónde envías',
          d: 'Cuando respondas, mira el campo “De” encima de la respuesta. Nukli elige la dirección a la que llegó el correo, pero puedes cambiarla con un clic.',
          screen: 'reply',
          highlight: 'foot',
        },
        {
          t: 'Dale un asistente a cada dirección',
          d: 'En Ajustes > Asistentes puedes asignar cuentas a cada asistente. Así el tono y la firma del trabajo nunca se cuelan en los correos personales.',
          screen: 'settings-assistants',
          highlight: 'list',
        },
      ],
      tips: [
        'Si una cuenta te estorba un día concreto, pliégala en la columna de buzones con la flecha de su nombre.',
        'Los grupos de carpetas ayudan mucho cuando tienes tres cuentas: mira la guía “Ordena la barra lateral”.',
      ],
      faq: [
        {
          q: '¿Se mezclarán los correos del trabajo con los personales?',
          a: 'Solo en la vista “Todas las bandejas”, y porque tú lo has pedido. Los correos nunca se mueven de sitio ni cambian de cuenta.',
        },
      ],
    },
    en: {
      title: 'Several addresses in one inbox',
      lead: 'Your personal address, your work one and the club one — together, but never mixed up.',
      answer:
        'You can add as many accounts as you like from the mailboxes panel. At the very top there is “All inboxes”, which shows everything together; below it, each account with its own folders. When replying, pick the sending address in the “From” field.',
      steps: [
        {
          t: 'Add the second account',
          d: 'Same as the first: mailboxes > Add account. There is no limit, and each account keeps its own folders.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'See it all together, or one at a time',
          d: 'At the top of the column is “All inboxes”, which merges every account by time. Just below it you have each account separately if you prefer.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Check which address you are sending from',
          d: 'When you reply, look at the “From” field above the message. Nukli picks the address the email arrived at, but you can change it with one click.',
          screen: 'reply',
          highlight: 'foot',
        },
        {
          t: 'Give each address its own assistant',
          d: 'In Settings > Assistants you can assign accounts to each assistant, so your work tone and signature never leak into personal replies.',
          screen: 'settings-assistants',
          highlight: 'list',
        },
      ],
      tips: [
        'If one account is in the way today, collapse it in the mailboxes column with the arrow next to its name.',
        'Folder groups help a lot with three accounts: see the guide “Tidy up the sidebar”.',
      ],
      faq: [
        {
          q: 'Will my work mail get mixed with my personal mail?',
          a: 'Only in the “All inboxes” view, and only because you asked for it. Emails never move or change account.',
        },
      ],
    },
  },

  {
    slug: 'the-nukli-screen',
    id: 'app-layout',
    category: 'start',
    icon: 'layout-dashboard',
    level: 'basic',
    plan: 'free',
    minutes: 4,
    overview: true,
    topics: [
      'pantalla', 'interfície', 'on és', 'no trobo el botó', 'pantalla de la app', 'dónde está',
      'no encuentro', 'interfaz', 'paneles', 'screen', 'layout', 'where is', 'panels',
      'para qué sirve cada cosa', 'què és cada cosa',
    ],
    ca: {
      title: 'La pantalla de Nukli, explicada',
      lead: 'Cinc zones i prou. Quan sàpigues quina és cadascuna, ja no et perdràs mai més.',
      answer:
        'La finestra de Nukli té cinc zones, d’esquerra a dreta: la barra d’icones, les bústies, la llista de correus, el correu obert i el panell de l’assistent. Gairebé tot el que busques és en una d’aquestes cinc.',
      steps: [
        {
          t: '1. La barra d’icones',
          d: 'La tira estreta de l’esquerra del tot. Hi ha les bústies, les regles, els assistents, les connexions, els col·laboradors, les notificacions, el mode fosc i la configuració. Passa-hi el ratolí per sobre i et dirà el nom de cada botó.',
          screen: 'inbox',
          highlight: 'rail',
        },
        {
          t: '2. Les bústies',
          d: 'La columna dels comptes i les carpetes: safata d’entrada, enviats, esborranys, correu brossa i les carpetes que tinguis. Es pot amagar per guanyar espai.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: '3. La llista de correus',
          d: 'Els missatges de la carpeta triada. A dalt hi ha el cercador i el botó per escriure un correu nou; a sota, les pestanyes Tots / Pendents / Fets.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: '4. El correu obert',
          d: 'El text del missatge que estàs llegint. A sota hi surten les respostes suggerides i els botons de Respon, Respon amb IA, Reenvia i Tradueix.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: '5. L’assistent',
          d: 'El panell de la dreta. Aquí li pots demanar coses amb paraules normals: que et resumeixi, que et redacti, que et busqui. Es pot tancar si un dia no el vols.',
          screen: 'chat',
          highlight: 'thread',
        },
      ],
      tips: [
        'Totes les separacions entre panells es poden arrossegar per fer-los més amples o més estrets.',
        'Si un panell desapareix, torna a la barra d’icones: gairebé sempre és un botó que s’ha quedat apagat.',
      ],
      faq: [
        {
          q: 'La pantalla em surt més petita, amb menys columnes',
          a: 'És normal: si la finestra és estreta o ets al telèfon, Nukli ensenya les zones d’una en una i vas endavant i enrere amb la fletxa de tornar.',
        },
      ],
    },
    es: {
      title: 'La pantalla de Nukli, explicada',
      lead: 'Cinco zonas y ya está. Cuando sepas cuál es cada una, no volverás a perderte.',
      answer:
        'La ventana de Nukli tiene cinco zonas, de izquierda a derecha: la barra de iconos, los buzones, la lista de correos, el correo abierto y el panel del asistente. Casi todo lo que buscas está en una de esas cinco.',
      steps: [
        {
          t: '1. La barra de iconos',
          d: 'La tira estrecha del extremo izquierdo. Ahí están los buzones, las reglas, los asistentes, las conexiones, los colaboradores, las notificaciones, el modo oscuro y los ajustes. Pasa el ratón por encima y te dirá el nombre de cada botón.',
          screen: 'inbox',
          highlight: 'rail',
        },
        {
          t: '2. Los buzones',
          d: 'La columna de cuentas y carpetas: bandeja de entrada, enviados, borradores, correo basura y las carpetas que tengas. Se puede ocultar para ganar espacio.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: '3. La lista de correos',
          d: 'Los mensajes de la carpeta elegida. Arriba está el buscador y el botón para escribir un correo nuevo; debajo, las pestañas Todos / Pendientes / Hechos.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: '4. El correo abierto',
          d: 'El texto del mensaje que estás leyendo. Debajo aparecen las respuestas sugeridas y los botones de Responder, Responder con IA, Reenviar y Traducir.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: '5. El asistente',
          d: 'El panel de la derecha. Aquí le pides cosas con palabras normales: que te resuma, que te redacte, que te busque. Se puede cerrar si algún día no lo quieres.',
          screen: 'chat',
          highlight: 'thread',
        },
      ],
      tips: [
        'Todas las separaciones entre paneles se pueden arrastrar para hacerlos más anchos o más estrechos.',
        'Si un panel desaparece, vuelve a la barra de iconos: casi siempre es un botón que se ha quedado apagado.',
      ],
      faq: [
        {
          q: 'A mí la pantalla me sale más pequeña, con menos columnas',
          a: 'Es normal: si la ventana es estrecha o estás en el móvil, Nukli enseña las zonas de una en una y vas adelante y atrás con la flecha de volver.',
        },
      ],
    },
    en: {
      title: 'The Nukli screen, explained',
      lead: 'Five areas, that is all. Once you know which is which, you will never be lost again.',
      answer:
        'The Nukli window has five areas, left to right: the icon bar, the mailboxes, the email list, the open email and the assistant panel. Almost everything you are looking for is in one of those five.',
      steps: [
        {
          t: '1. The icon bar',
          d: 'The narrow strip on the far left. It holds mailboxes, rules, assistants, connections, collaborators, notifications, dark mode and settings. Hover over a button and it tells you its name.',
          screen: 'inbox',
          highlight: 'rail',
        },
        {
          t: '2. The mailboxes',
          d: 'The column of accounts and folders: inbox, sent, drafts, junk and any folders you have. You can hide it to gain space.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: '3. The email list',
          d: 'The messages in the chosen folder. Search and the “new email” button sit at the top; below them the All / Pending / Done tabs.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: '4. The open email',
          d: 'The message you are reading. Underneath it you get the suggested replies and the Reply, Reply with AI, Forward and Translate buttons.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: '5. The assistant',
          d: 'The panel on the right. Ask it things in plain words: summarise this, draft that, find the other. You can close it on days you do not want it.',
          screen: 'chat',
          highlight: 'thread',
        },
      ],
      tips: [
        'Every divider between panels can be dragged to make them wider or narrower.',
        'If a panel vanishes, go back to the icon bar: it is nearly always a button that got switched off.',
      ],
      faq: [
        {
          q: 'My screen is smaller, with fewer columns',
          a: 'That is normal: on a narrow window or a phone, Nukli shows the areas one at a time and you move back and forth with the back arrow.',
        },
      ],
    },
  },

  {
    slug: 'read-and-reply',
    id: 'read-reply',
    category: 'start',
    icon: 'reply',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'llegir correu', 'respondre', 'leer correo', 'responder', 'contestar', 'read email', 'reply',
      'cómo respondo', 'com responc', 'enviar respuesta', 'send reply', 'reenviar', 'forward',
      'responder a todos', 'reply all',
    ],
    ca: {
      title: 'Llegir un correu i respondre’l',
      lead: 'El gest de cada dia, sense IA ni res estrany: obrir, llegir, escriure i enviar.',
      answer:
        'Fes clic al correu de la llista per obrir-lo a la dreta. A sota del missatge prem “Respon”, escriu i envia amb el botó blau (o amb ⌘/Ctrl + Enter). Per enviar-lo a una altra persona, prem “Reenvia”.',
      steps: [
        {
          t: 'Tria el correu',
          d: 'Un clic a la fila de la llista. El missatge s’obre al panell del costat i queda marcat com a llegit.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Llegeix-lo sencer',
          d: 'Si el correu ve d’una conversa llarga, hi haurà un enllaç per ensenyar el text citat de sota. Els adjunts són al final del missatge.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Prem “Respon”',
          d: 'És el botó fosc de la barra de sota. S’obre una caixa de text amb el destinatari ja posat.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Escriu i envia',
          d: 'Escriu el que vulguis i prem el botó d’enviar. Si prefereixes el teclat: ⌘ + Enter al Mac, Ctrl + Enter a Windows.',
          screen: 'reader',
          highlight: 'actions',
          tip: 'Si tanques la caixa sense enviar, el text queda desat als esborranys.',
        },
      ],
      tips: [
        'Per enviar el correu a una altra persona, fes servir “Reenvia” en comptes de “Respon”.',
        'Per posar algú en còpia, obre els destinataris a dalt de la caixa i afegeix-lo al camp Cc.',
      ],
      faq: [
        {
          q: 'On han anat a parar els correus que he escrit?',
          a: 'A la carpeta “Enviats” del compte des del qual has escrit, a la columna de bústies.',
        },
        {
          q: 'He tancat la resposta sense voler',
          a: 'No l’has perduda: obre el botó d’esborranys de la mateixa caixa de resposta i la recuperes.',
        },
      ],
    },
    es: {
      title: 'Leer un correo y responderlo',
      lead: 'El gesto de cada día, sin IA ni nada raro: abrir, leer, escribir y enviar.',
      answer:
        'Haz clic en el correo de la lista para abrirlo a la derecha. Debajo del mensaje pulsa “Responder”, escribe y envía con el botón azul (o con ⌘/Ctrl + Enter). Para mandárselo a otra persona, pulsa “Reenviar”.',
      steps: [
        {
          t: 'Elige el correo',
          d: 'Un clic en la fila de la lista. El mensaje se abre en el panel de al lado y queda marcado como leído.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Léelo entero',
          d: 'Si el correo viene de una conversación larga, habrá un enlace para mostrar el texto citado de debajo. Los adjuntos están al final del mensaje.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Pulsa “Responder”',
          d: 'Es el botón oscuro de la barra de abajo. Se abre una caja de texto con el destinatario ya puesto.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Escribe y envía',
          d: 'Escribe lo que quieras y pulsa el botón de enviar. Si prefieres el teclado: ⌘ + Enter en Mac, Ctrl + Enter en Windows.',
          screen: 'reader',
          highlight: 'actions',
          tip: 'Si cierras la caja sin enviar, el texto se guarda en los borradores.',
        },
      ],
      tips: [
        'Para mandar el correo a otra persona usa “Reenviar” en lugar de “Responder”.',
        'Para poner a alguien en copia, abre los destinatarios encima de la caja y añádelo al campo Cc.',
      ],
      faq: [
        {
          q: '¿Dónde van a parar los correos que he escrito?',
          a: 'A la carpeta “Enviados” de la cuenta desde la que has escrito, en la columna de buzones.',
        },
        {
          q: 'He cerrado la respuesta sin querer',
          a: 'No la has perdido: abre el botón de borradores de la propia caja de respuesta y la recuperas.',
        },
      ],
    },
    en: {
      title: 'Reading an email and replying',
      lead: 'The everyday move, with no AI involved: open, read, write, send.',
      answer:
        'Click the email in the list to open it on the right. Under the message press “Reply”, write, and send with the blue button (or ⌘/Ctrl + Enter). To pass it on to someone else, press “Forward”.',
      steps: [
        {
          t: 'Pick the email',
          d: 'One click on the row in the list. The message opens in the panel next to it and is marked as read.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Read the whole thing',
          d: 'If it comes from a long conversation there is a link to show the quoted text below. Attachments sit at the end of the message.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Press “Reply”',
          d: 'The dark button in the bar underneath. A text box opens with the recipient already filled in.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Write and send',
          d: 'Type what you want and press send. If you prefer the keyboard: ⌘ + Enter on Mac, Ctrl + Enter on Windows.',
          screen: 'reader',
          highlight: 'actions',
          tip: 'If you close the box without sending, the text is kept in your drafts.',
        },
      ],
      tips: [
        'To pass an email on to someone else use “Forward”, not “Reply”.',
        'To copy somebody in, open the recipients above the box and add them to the Cc field.',
      ],
      faq: [
        {
          q: 'Where do the emails I write end up?',
          a: 'In the “Sent” folder of the account you wrote from, in the mailboxes column.',
        },
        {
          q: 'I closed the reply by accident',
          a: 'It is not lost: open the drafts button in the reply box itself and get it back.',
        },
      ],
    },
  },

  {
    slug: 'bigger-and-comfortable',
    id: 'view-comfort',
    category: 'start',
    icon: 'eye',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'lletra més gran', 'letra más grande', 'zoom', 'veo mal', 'no veo bien', 'modo oscuro',
      'mode fosc', 'dark mode', 'bigger text', 'font size', 'ampliar', 'cansa la vista',
      'idioma de la app', 'cambiar idioma', 'canviar idioma', 'app language',
    ],
    ca: {
      title: 'Veure-ho més gran i més còmode',
      lead: 'Si la lletra et queda petita o la pantalla et cansa la vista, tot això té solució en un minut.',
      answer:
        'Amplia tota la finestra amb ⌘/Ctrl i la tecla +. Canvia entre clar i fosc amb el botó de la lluna, a la part baixa de la barra d’icones. I arrossega les separacions entre panells per donar més espai al text del correu.',
      steps: [
        {
          t: 'Fes la lletra més gran',
          d: 'Prem ⌘ + tecla “+” al Mac o Ctrl + “+” a Windows tantes vegades com calgui. Amb ⌘/Ctrl + 0 tornes a la mida original.',
        },
        {
          t: 'Passa a mode fosc (o clar)',
          d: 'A la part baixa de la barra d’icones hi ha un botó amb una lluna o un sol. El mode fosc cansa menys de nit; el clar es llegeix millor de dia.',
          screen: 'inbox',
          highlight: 'rail',
        },
        {
          t: 'Dona més espai al correu',
          d: 'Arrossega la ratlla que separa la llista del correu obert cap a l’esquerra. També pots amagar les bústies i tancar l’assistent quan no els facis servir.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Posa la app en el teu idioma',
          d: 'A Configuració > General, a l’apartat “Idioma”, tries el dels botons i els menús. No afecta els correus, que es queden com estan.',
          screen: 'settings-general',
          highlight: 'language',
        },
      ],
      tips: [
        'Dins d’un correu concret pots prémer “Amplada completa” per fer que el text ocupi tota la finestra.',
        'La caixa de resposta es pot fer més alta arrossegant la seva vora de dalt; amb doble clic torna a la mida normal.',
      ],
      faq: [
        {
          q: 'Puc fer gran només el text del correu i no tota la app?',
          a: 'El zoom afecta tota la finestra, que sol ser el que interessa. Si un correu concret ve amb lletra minúscula, prova l’amplada completa i el zoom.',
        },
      ],
    },
    es: {
      title: 'Verlo más grande y más cómodo',
      lead: 'Si la letra se te queda pequeña o la pantalla te cansa la vista, todo eso tiene arreglo en un minuto.',
      answer:
        'Amplía toda la ventana con ⌘/Ctrl y la tecla +. Cambia entre claro y oscuro con el botón de la luna, en la parte baja de la barra de iconos. Y arrastra las separaciones entre paneles para dar más sitio al texto del correo.',
      steps: [
        {
          t: 'Haz la letra más grande',
          d: 'Pulsa ⌘ + tecla “+” en Mac o Ctrl + “+” en Windows tantas veces como haga falta. Con ⌘/Ctrl + 0 vuelves al tamaño original.',
        },
        {
          t: 'Pasa a modo oscuro (o claro)',
          d: 'En la parte baja de la barra de iconos hay un botón con una luna o un sol. El modo oscuro cansa menos de noche; el claro se lee mejor de día.',
          screen: 'inbox',
          highlight: 'rail',
        },
        {
          t: 'Dale más sitio al correo',
          d: 'Arrastra la raya que separa la lista del correo abierto hacia la izquierda. También puedes ocultar los buzones y cerrar el asistente cuando no los uses.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Pon la app en tu idioma',
          d: 'En Ajustes > General, en el apartado “Idioma”, eliges el de los botones y los menús. No afecta a los correos, que se quedan como están.',
          screen: 'settings-general',
          highlight: 'language',
        },
      ],
      tips: [
        'Dentro de un correo concreto puedes pulsar “Ancho completo” para que el texto ocupe toda la ventana.',
        'La caja de respuesta se puede hacer más alta arrastrando su borde superior; con doble clic vuelve al tamaño normal.',
      ],
      faq: [
        {
          q: '¿Puedo agrandar solo el texto del correo y no toda la app?',
          a: 'El zoom afecta a toda la ventana, que suele ser lo que interesa. Si un correo concreto viene con letra minúscula, prueba el ancho completo junto con el zoom.',
        },
      ],
    },
    en: {
      title: 'Making it bigger and easier on the eyes',
      lead: 'If the text is too small or the screen tires your eyes, all of this is a one-minute fix.',
      answer:
        'Zoom the whole window with ⌘/Ctrl and the + key. Switch between light and dark with the moon button near the bottom of the icon bar. And drag the dividers between panels to give the message more room.',
      steps: [
        {
          t: 'Make the text bigger',
          d: 'Press ⌘ and “+” on a Mac, or Ctrl and “+” on Windows, as many times as you need. ⌘/Ctrl + 0 puts it back to normal.',
        },
        {
          t: 'Switch to dark mode (or light)',
          d: 'Near the bottom of the icon bar there is a moon or sun button. Dark mode is kinder at night; light mode reads better in daylight.',
          screen: 'inbox',
          highlight: 'rail',
        },
        {
          t: 'Give the email more room',
          d: 'Drag the line between the list and the open email to the left. You can also hide the mailboxes and close the assistant when you are not using them.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Put the app in your language',
          d: 'Settings > General, under “Language”, sets the language of the buttons and menus. It does not touch your emails.',
          screen: 'settings-general',
          highlight: 'language',
        },
      ],
      tips: [
        'Inside a particular email you can press “Full width” so the text uses the whole window.',
        'The reply box can be made taller by dragging its top edge; double-click resets it.',
      ],
      faq: [
        {
          q: 'Can I enlarge only the message text and not the whole app?',
          a: 'Zoom applies to the whole window, which is usually what you want. If one email arrives in tiny type, try full width together with zoom.',
        },
      ],
    },
  },
];
